import { useEffect, useState } from "react";
import { ContractService } from "../../core/services/ContractService";
import { AccountEditor } from "../editor/AccountEditor";
import { useDashboardStore } from "../pages/hooks/useDashboardStore";
import { BasicButton } from "../theme/Component/BasicButton";

interface Props {
    idAdquisitionItem: number;
    updateFather?:Function;
}

export const AdquisitionItemAnalyst = ({ idAdquisitionItem,updateFather }: Props) => {

    const { setLoading } = useDashboardStore();
    const service = new ContractService();
    const [item, setItem] = useState<any>({});
    const [analyst, setAnalyst] = useState<any>({});

    useEffect(() => {
        getAdquisitionItem();

    }, [idAdquisitionItem])
    useEffect(() => {

        updateItem();
    }, [analyst])
    useEffect(() => {

       //console.log("update");

    }, [item])

    const getAdquisitionItem = () => {
        setLoading(true);
        service.getAdquisitionItem(idAdquisitionItem).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setItem(resp.DataBeanProperties.ObjectValue.DataBeanProperties);
                }
                setLoading(false);
            }
        )
    }

    const updateItem = () => {
        setLoading(true);
        let b = item;
        b.IDAccountAnalyst = analyst.IDAccount;
       //console.log(b);

        service.updateAdquisitionItem(b).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setItem(resp.DataBeanProperties.ObjectValue.DataBeanProperties);
                }
                setLoading(false);
                if(updateFather)
                    updateFather(true);
            }
        )
    }

    return (
        <>
            {/* <PrintJson json={item}/> */}
            <div className="row">
                <div className="col-md-12">
                    <AccountEditor idAccount={item.IDAccountAnalyst} label="Funcionario" onChange={(e: any) => { setAnalyst(e) }}></AccountEditor>
                </div>
                {/* <div className="col-md-12">
                    <BasicButton disable={!analyst.IDAccount} icon="" eventClick={updateItem}>Actualizar</BasicButton>
                </div> */}
            </div>
        </>
    )
}